import React, { useEffect } from "react";
import '../../Styles/Photosection.css';
import Photosection from "./Photosection";
import Picsroutes from "./Picsroutes";
import {
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Photoslanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("PhotosLanding mounted");
  }, []);

  return (
    <div style={{ backgroundColor: "#FFF7D9" }}>
      <Photosection />
      <main className="pic-slides">
        <Picsroutes />
      </main>

      {/* FOOTER */}
      <footer className="photo-footer">
        <div className="photo-footer-left">
          <span className="photo-footer-icon">🖼️</span>
          <span className="photo-footer-text">
            © 2024 Inturi Nageswara Rao. All Rights Reserved.
          </span>
        </div>

        <div className="photo-footer-right">
          <span className="photo-footer-follow">Follow Us :</span>
          <div className="photo-social-icons">
            <a href="https://wa.me/" target="_blank" rel="noreferrer" className="photo-social-icon whatsapp" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href="https://facebook.com/" target="_blank" rel="noreferrer" className="photo-social-icon facebook" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer" className="photo-social-icon twitter" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="photo-social-icon instagram" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://youtube.com/" target="_blank" rel="noreferrer" className="photo-social-icon youtube" aria-label="YouTube">
              <FaYoutube />
            </a>
          </div>
        </div>
      </footer>

      <div className="photo-credit-bar">
        Designed and Developed by <span>YSK Infotech Pvt Ltd</span>
      </div>
    </div>
  );
};

export default Photoslanding;